<div class="container" *ngIf="!isLoadingMigrations; else migrationsLoading">
  <h6 class="header">Prosync Migration orders</h6>
  <table>
    <thead>
      <tr>
        <th>Pro Account Id</th>
        <th>Pro Account Name</th>
        <th>Section</th>
        <th>State</th>
        <th>Go</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let migration of migrations">
        <td>{{ migration.proAccountId }}</td>
        <td class="pro-account-name">{{ migration.proAccountName }}</td>
        <td>{{ migration.sectionId }}</td>
        <td>
          <span
            [ngClass]="
              'badge badge-' + getMigrationStateClass(migration.status)
            "
          >
            {{ migration.status }}
          </span>
        </td>
        <td class="button-td">
          <button
            (click)="goTo(migration.oneAccountId, migration.proAccountId)"
            class="btn btn-sm btn-primary"
          >
            <i class="fas fa-directions btn-icon"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #migrationsLoading>
  <app-loading-spinner></app-loading-spinner>
</ng-template>
